<template>
  <div>
    <section-title
      has-line
      subtitle="Las expectativas añadidas estarán disponibles para seleccionar al momento
      de crear una sección de preguntas."
      subtitle-class="text-gray"
      subtitle-icon="fal fa-exclamation-circle"
      title="Configuración de Expectativas"
    />

    <div class="mt-4 panel-content">
      <div class="row">
        <div class="col-lg-3 col-md-12 boder">
          <validation-observer ref="formValidator">
            <div class="row">
              <div class="col-12 mb-4">
                <validation-provider v-slot="{ errors }" rules="required">
                  <div class="text">
                    Nombre de la Expectativa:
                  </div>
                  <custom-drop-down
                    v-model="model.answer"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="availableAnswers"
                    placeholder="Seleccione"
                  />
                </validation-provider>
                <validation-provider
                  v-if="isOther"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <custom-input
                    v-model="model.other"
                    class="mt-3"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    placeholder="Expectativa"
                  />
                </validation-provider>
              </div>
              <div class="col-12 mb-4">
                <div class="text">
                  Seleccione Color:
                </div>
                <div
                  class="d-flex justify-content-between"
                  style="padding: 6px; background: white; border-radius: 4px; align-items: center; gap: 12px; display: inline-flex"
                >
                  <color
                    v-for="item in colors"
                    :key="item.id"
                    :color="item.id"
                    :disabled="item.disabled"
                    :selected="item.selected"
                    @selected="onColorSelected"
                  />
                </div>
                <custom-error
                  v-if="showError && !this.model.color"
                  :message="'El campo es requerido'"
                  variant="no-border mt-1"
                />
              </div>
            </div>
            <div>
              <action-button
                class="mt-3"
                :disabled="!canAddAnswer"
                i="fas fa-file-plus"
                text="Añadir Expectativa"
                variant="success"
                @click="add()"
              />
            </div>
          </validation-observer>
        </div>
        <div class="col-lg-9 col-md-12">
          <div class="text">
            Seleccionado(s):
          </div>
          <div class="answer-content">
            <chip
              v-for="(answer, index) in input"
              :key="index"
              :index="index"
              :model="answer"
              @delete="onDeleteHandler"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import { getAnswers } from '@/modules/rubric/api.js';
import Chip from './Chip';
import Color from './Color';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomInput from 'CustomInput';
import CustomError from 'custom-error';

export default {
  name: 'Expectation',
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
    Color,
    Chip,
    CustomInput,
    CustomError,
  },
  mixins: [alertMixin],
  props: {
    input: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: {
        answer: null,
        color: null,
        other: null,
      },
      answers: [],
      colors: [
        { id: '#FF9C9A', disabled: false, selected: false },
        { id: '#FAE76F', disabled: false, selected: false },
        { id: '#F8B184', disabled: false, selected: false },
        { id: '#DDB3D7', disabled: false, selected: false },
        { id: '#A3E5B3', disabled: false, selected: false },
        { id: '#9CDDD5', disabled: false, selected: false },
        { id: '#B5C3BC', disabled: false, selected: false },
        { id: '#606E70', disabled: false, selected: false },
      ],
      showError: false,
    };
  },
  computed: {
    canAddAnswer() {
      return this.input.length < 5;
    },
    availableAnswers() {
      return this.answers.filter(
        (x) => !this.input.map((x) => x.id).includes(x.id)
      );
    },
    isOther() {
      return this.model.answer?.id === -1;
    },
  },
  async mounted() {
    await this.getAnswers();
  },
  methods: {
    async add() {
      this.showError = false;
      const valid = await this.$refs.formValidator.validate();

      if (!valid || !this.model.color) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );

        this.showError = true;

        return;
      }
      const data = {
        id: this.model.answer.id === -1 ? null : this.model.answer.id,
        text:
          this.model.answer.id === -1
            ? this.model.other
            : this.model.answer.name,
        color: this.model.color,
      };
      this.input.push(data);

      this.toggleColor(this.model.color, true);

      this.model.answer = null;
      this.model.color = null;
      this.model.other = null;

      this.colors.map((x) => (x.selected = false));
      this.$refs.formValidator.reset();
      this.$emit('add', data);
    },
    async getAnswers() {
      const { data } = await getAnswers();
      this.answers = data;
      this.answers.push({ id: -1, name: 'Otro' });
    },
    onDeleteHandler(data) {
      const itemIndex = this.input.findIndex((x) => x.id === data.id);
      this.input.splice(itemIndex, 1);

      this.toggleColor(data.color);
      this.$emit('quit', data);
    },
    onColorSelected(data) {
      this.model.color = data;

      this.colors.map((x) => (x.selected = false));

      const color = this.colors.find((x) => x.id === data);
      color.selected = true;
    },
    toggleColor(id, disable = false) {
      const color = this.colors.find((x) => x.id === id);
      color.disabled = disable;
    },
    async validate() {
      if (this.input.length > 0) return true;

      this.ShowToast(
        'Error',
        'Es necesario seleccionar al menos una expectativa para guardar.',
        'error'
      );

      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.text-gray {
  color: #727272;
}

.boder {
  border-right: 1px #b5c3bc solid;
}

.panel-content {
  padding: 24px;
  background: #f7f7f7;
  border-radius: 4px;
}

.text {
  margin-bottom: 5px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  letter-spacing: -0.005em;
  text-align: left;
}

.answer-content {
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  display: inline-flex;
}
</style>
